import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
//@ts-nocheck
import LRU from 'quick-lru';
import { CacheSemantics } from './cacheSemantics';
import AggregatingFetcher from './aggregatingFetcher';
import crossFetchBinaryRange from './crossFetchBinaryRange';
/**
 * check if the given exception was caused by an operation being intentionally aborted
 * @param {Error} exception
 * @returns {boolean}
 */
function isAbortException(exception) {
  return (
    // DOMException
    exception.name === 'AbortError' ||
    // standard-ish non-DOM abort exception
    // @ts-ignore
    exception.code === 'ERR_ABORTED' ||
    // message contains aborted for bubbling through RPC
    // things we have seen that we want to catch here
    // Error: aborted
    // AbortError: aborted
    // AbortError: The user aborted a request.
    !!exception.message.match(/\b(aborted|AbortError)\b/i)
  );
}
// TODO: fire events when a remote file is detected as having been changed
/**
 * smart cache that fetches chunks of remote files.
 * caches chunks in an LRU cache, and aggregates upstream fetches
 */
var HttpRangeFetcher = /*#__PURE__*/function () {
  /**
   * @param {object} args the arguments object
   * @param {number} [args.fetch] callback with signature `(key, start, end) => Promise({ headers, buffer })`
   * @param {number} [args.size] size in bytes of cache to keep
   * @param {number} [args.chunkSize] size in bytes of cached chunks
   * @param {number} [args.aggregationTime] time in ms over which to pool requests before dispatching them
   * @param {number} [args.minimumTTL] time in ms a non-cacheable response will be cached
   * @param {number} [args.maxFetchSize] maximum size of an aggregated request
   * @param {number} [args.maxExtraFetch] max number of additional bytes to fetch when aggregating requests
   * that don't actually overlap
   */
  function HttpRangeFetcher(_ref) {
    var _ref$fetch = _ref.fetch,
      fetch = _ref$fetch === void 0 ? crossFetchBinaryRange : _ref$fetch,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 10000000 : _ref$size,
      _ref$chunkSize = _ref.chunkSize,
      chunkSize = _ref$chunkSize === void 0 ? 32768 : _ref$chunkSize,
      _ref$aggregationTime = _ref.aggregationTime,
      aggregationTime = _ref$aggregationTime === void 0 ? 100 : _ref$aggregationTime,
      _ref$minimumTTL = _ref.minimumTTL,
      minimumTTL = _ref$minimumTTL === void 0 ? 1000 : _ref$minimumTTL,
      _ref$maxFetchSize = _ref.maxFetchSize,
      maxFetchSize = _ref$maxFetchSize === void 0 ? chunkSize * 4 : _ref$maxFetchSize,
      _ref$maxExtraFetch = _ref.maxExtraFetch,
      maxExtraFetch = _ref$maxExtraFetch === void 0 ? chunkSize : _ref$maxExtraFetch;
    _classCallCheck(this, HttpRangeFetcher);
    this.aggregator = new AggregatingFetcher({
      fetch: fetch,
      frequency: aggregationTime,
      maxFetchSize: maxFetchSize,
      maxExtraSize: maxExtraFetch
    });
    this.chunkSize = chunkSize;
    this.chunkCache = new LRU({
      maxSize: Math.floor(size / chunkSize) || 1
    });
    this.cacheSemantics = new CacheSemantics({
      minimumTTL: minimumTTL
    });
    this.stats = new LRU({
      maxSize: 20
    });
  }
  /**
   * Fetch a range of a remote resource.
   * @param {string} key the resource's unique identifier, this would usually be a URL.
   * This is passed along to the fetch callback.
   * @param {number} [position] offset in the file at which to start fetching
   * @param {number} [length] number of bytes to fetch, defaults to the remainder of the file
   * @param {object} [options] request options
   * @param {AbortSignal} [options.signal] AbortSignal object that can be used to abort the fetch
   */
  _createClass(HttpRangeFetcher, [{
    key: "getRange",
    value: function () {
      var _getRange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(key) {
        var _this = this;
        var position,
          requestedLength,
          options,
          length,
          stat,
          firstChunk,
          lastChunk,
          fetches,
          _loop,
          chunk,
          chunkResponses,
          chunksOffset,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              position = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 0;
              requestedLength = _args2.length > 2 ? _args2[2] : undefined;
              options = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
              length = requestedLength;
              if (!(length === undefined)) {
                _context2.next = 11;
                break;
              }
              _context2.next = 7;
              return this.stat(key);
            case 7:
              stat = _context2.sent;
              if (!(stat.size === undefined)) {
                _context2.next = 10;
                break;
              }
              throw new Error("length not specified, and could not determine size of the remote file");
            case 10:
              length = stat.size - position;
            case 11:
              // calculate the list of chunks involved in this fetch
              firstChunk = Math.floor(position / this.chunkSize);
              lastChunk = Math.floor((position + length - 1) / this.chunkSize); // fetch them all as necessary
              fetches = new Array(lastChunk - firstChunk + 1);
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(chunk) {
                return _regeneratorRuntime().wrap(function _loop$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      fetches[chunk - firstChunk] = _this._getChunk(key, chunk, options).then(function (response) {
                        return response && {
                          headers: response.headers,
                          buffer: response.buffer,
                          chunkNumber: chunk
                        };
                      });
                    case 1:
                    case "end":
                      return _context.stop();
                  }
                }, _loop);
              });
              chunk = firstChunk;
            case 16:
              if (!(chunk <= lastChunk)) {
                _context2.next = 21;
                break;
              }
              return _context2.delegateYield(_loop(chunk), "t0", 18);
            case 18:
              chunk += 1;
              _context2.next = 16;
              break;
            case 21:
              _context2.next = 23;
              return Promise.all(fetches);
            case 23:
              chunkResponses = _context2.sent;
              chunkResponses = chunkResponses.filter(function (r) {
                return !!r;
              }); // filter out any undefined (out of range) responses
              if (chunkResponses.length) {
                _context2.next = 27;
                break;
              }
              return _context2.abrupt("return", {
                headers: {},
                buffer: Buffer.allocUnsafe(0)
              });
            case 27:
              chunksOffset = position - chunkResponses[0].chunkNumber * this.chunkSize;
              return _context2.abrupt("return", {
                headers: this._makeHeaders(chunkResponses[0].headers, position, position + length - 1),
                buffer: this._makeBuffer(chunkResponses, chunksOffset, length)
              });
            case 29:
            case "end":
              return _context2.stop();
          }
        }, _callee, this);
      }));
      function getRange(_x) {
        return _getRange.apply(this, arguments);
      }
      return getRange;
    }()
  }, {
    key: "_makeBuffer",
    value: function _makeBuffer(chunkResponses, chunksOffset, length) {
      if (chunkResponses.length === 1) {
        return chunkResponses[0].buffer.slice(chunksOffset, chunksOffset + length);
      } else if (chunkResponses.length === 0) {
        return Buffer.allocUnsafe(0);
      }
      // 2 or more buffers
      var buffers = chunkResponses.map(function (r) {
        return r.buffer;
      });
      var first = buffers.shift().slice(chunksOffset);
      var last = buffers.pop();
      var trimEnd = first.length + buffers.reduce(function (sum, buf) {
        return sum + buf.length;
      }, 0) + last.length - length;
      if (trimEnd < 0) {
        trimEnd = 0;
      }
      last = last.slice(0, last.length - trimEnd);
      return Buffer.concat([first].concat(_toConsumableArray(buffers), [last]));
    }
    /**
     * Fetches the first few bytes of the remote file (if necessary) and uses
     * the returned headers to populate a `fs`-like stat object.
     *
     * Currently, this attempts to set `size`, `mtime`, and `mtimeMs`, if
     * the information is available from HTTP headers.
     *
     * @param {string} key
     * @returns {Promise} for a stats object
     */
  }, {
    key: "stat",
    value: function () {
      var _stat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(key) {
        var stat, chunk;
        return _regeneratorRuntime().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              stat = this.stats.get(key);
              if (stat) {
                _context3.next = 9;
                break;
              }
              _context3.next = 4;
              return this._getChunk(key, 0);
            case 4:
              chunk = _context3.sent;
              this._recordStatsIfNecessary(key, chunk);
              stat = this.stats.get(key);
              if (stat) {
                _context3.next = 9;
                break;
              }
              throw new Error("failed to retrieve file size for ".concat(key));
            case 9:
              return _context3.abrupt("return", stat);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
      function stat(_x2) {
        return _stat.apply(this, arguments);
      }
      return stat;
    }()
  }, {
    key: "_headersToStats",
    value: function _headersToStats(chunkResponse) {
      var headers = chunkResponse.headers;
      var stat = {};
      if (headers['content-range']) {
        var match = headers['content-range'].match(/\d+-\d+\/(\d+)/);
        if (match) {
          stat.size = parseInt(match[1], 10);
          if (Number.isNaN(stat.size)) {
            delete stat.size;
          }
        }
      }
      if (headers['last-modified']) {
        stat.mtime = new Date(headers['last-modified']);
        if (stat.mtime.toString() === 'Invalid Date') {
          delete stat.mtime;
        }
        if (stat.mtime) {
          stat.mtimeMs = stat.mtime.getTime();
        }
      }
      return stat;
    }
  }, {
    key: "_makeHeaders",
    value: function _makeHeaders(originalHeaders, newStart, newEnd) {
      var newHeaders = Object.assign({}, originalHeaders || {});
      newHeaders['content-length'] = newEnd - newStart;
      var oldContentRange = newHeaders['content-range'] || '';
      var match = oldContentRange.match(/\d+-\d+\/(\d+)/);
      if (match) {
        newHeaders['content-range'] = "".concat(newStart, "-").concat(newEnd - 1, "/").concat(match[1]);
        // eslint-disable-next-line prefer-destructuring
        newHeaders['x-resource-length'] = match[1];
      }
      return newHeaders;
    }
  }, {
    key: "_getChunk",
    value: function () {
      var _getChunk2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(key, chunkNumber, requestOptions) {
        var _this2 = this;
        var chunkKey, cachedPromise, chunk, chunkAborted, fetchStart, fetchEnd, stat, alreadyRejected, freshPromise, freshChunk;
        return _regeneratorRuntime().wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              chunkKey = "".concat(key, "/").concat(chunkNumber);
              cachedPromise = this.chunkCache.get(chunkKey);
              if (!cachedPromise) {
                _context4.next = 21;
                break;
              }
              _context4.prev = 3;
              _context4.next = 6;
              return cachedPromise;
            case 6:
              chunk = _context4.sent;
              _context4.next = 16;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](3);
              if (!isAbortException(_context4.t0)) {
                _context4.next = 15;
                break;
              }
              // fetch was aborted
              chunkAborted = true;
              _context4.next = 16;
              break;
            case 15:
              throw _context4.t0;
            case 16:
              if (!(chunkAborted || !this.cacheSemantics.cachedChunkIsValid(chunk))) {
                _context4.next = 19;
                break;
              }
              this._uncacheIfSame(chunkKey, cachedPromise);
              return _context4.abrupt("return", this._getChunk(key, chunkNumber, requestOptions));
            case 19:
              // gather the stats for the file from the headers
              this._recordStatsIfNecessary(key, chunk);
              return _context4.abrupt("return", chunk);
            case 21:
              fetchStart = chunkNumber * this.chunkSize;
              fetchEnd = fetchStart + this.chunkSize; // clamp the end of the fetch to the size if we have a cached size for the file
              stat = this.stats.get(key);
              if (!(stat && stat.size)) {
                _context4.next = 28;
                break;
              }
              if (!(fetchStart >= stat.size)) {
                _context4.next = 27;
                break;
              }
              return _context4.abrupt("return", undefined);
            case 27:
              if (fetchEnd >= stat.size) {
                fetchEnd = stat.size;
              }
            case 28:
              alreadyRejected = false;
              freshPromise = this.aggregator.fetch(key, fetchStart, fetchEnd, requestOptions).catch(function (err) {
                // if the request fails, remove its promise
                // from the cache and keep the error
                alreadyRejected = true;
                _this2._uncacheIfSame(chunkKey, freshPromise);
                throw err;
              });
              if (!alreadyRejected) {
                this.chunkCache.set(chunkKey, freshPromise);
              }
              _context4.next = 33;
              return freshPromise;
            case 33:
              freshChunk = _context4.sent;
              // gather the stats for the file from the headers
              this._recordStatsIfNecessary(key, freshChunk);
              // remove the promise from the cache
              // if it turns out not to be cacheable. this is
              // done after the fact because we want multiple requests
              // for the same chunk to reuse the same cached promise
              if (!this.cacheSemantics.chunkIsCacheable(freshChunk)) {
                this._uncacheIfSame(chunkKey, freshPromise);
              }
              return _context4.abrupt("return", freshChunk);
            case 37:
            case "end":
              return _context4.stop();
          }
        }, _callee3, this, [[3, 9]]);
      }));
      function _getChunk(_x3, _x4, _x5) {
        return _getChunk2.apply(this, arguments);
      }
      return _getChunk;
    }() // if the stats for a resource haven't been recorded yet, record them
  }, {
    key: "_recordStatsIfNecessary",
    value: function _recordStatsIfNecessary(key, chunk) {
      if (!this.stats.has(key)) {
        this.stats.set(key, this._headersToStats(chunk));
      }
    } // delete a promise from the cache if it is still in there.
    // need to check if it is still the same because it might
    // have been overwritten sometime while the promise was in flight
  }, {
    key: "_uncacheIfSame",
    value: function _uncacheIfSame(key, cachedPromise) {
      if (this.chunkCache.get(key) === cachedPromise) {
        this.chunkCache.delete(key);
      }
    }
    /**
     * Throw away all cached data, resetting the cache.
     */
  }, {
    key: "reset",
    value: function reset() {
      this.stats.clear();
      this.chunkCache.clear();
    }
  }]);
  return HttpRangeFetcher;
}();
export { HttpRangeFetcher as default };